import { type FC } from 'react';
import classnames from 'classnames';
import ChevronDown from 'dibs-icons/exports/ChevronDown.ts';
import ChevronUp from 'dibs-icons/exports/ChevronUp.ts';
import { Link } from 'dibs-elements/exports/Link.tsx';

import dibsCss from 'dibs-css';
import styles from './SbSharedQuickFilterChip.module.css';

type Props = {
    appliedFilterCount: number;
    isActive: boolean;
    isLoading: boolean;
    linkRef?: (node: HTMLAnchorElement | HTMLButtonElement | null) => void;
    localizedFilterName: string;
    onClick: () => void;
};

export const SbSharedQuickFilterChip: FC<Props> = ({
    appliedFilterCount,
    isActive,
    isLoading,
    linkRef,
    localizedFilterName,
    onClick,
}: Props) => {
    return (
        <Link
            key={localizedFilterName}
            className={classnames(
                styles.chip,
                dibsCss.textBodySmallNormal,
                dibsCss.whitespaceNowrap,
                dibsCss.roundedFull,
                {
                    [styles.active]: isActive,
                    [styles.disabled]: isLoading,
                    [dibsCss.textGray500]: isLoading,
                }
            )}
            linkRef={linkRef}
            onClick={onClick}
            underline="none"
        >
            <div
                className={classnames(
                    dibsCss.textBodySmallHeavy,
                    dibsCss.flex,
                    dibsCss.itemsCenter,
                    dibsCss.gapXxsmall,
                    { [dibsCss.textGray500]: isLoading, [dibsCss.fillGray500]: isLoading }
                )}
            >
                {localizedFilterName}
                {appliedFilterCount === 1 && ` (${appliedFilterCount})`}
                {appliedFilterCount > 1 && ` (1+)`}
                {isActive ? <ChevronUp variation="20" /> : <ChevronDown variation="20" />}
            </div>
        </Link>
    );
};
